module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAABZ0lEQVQ4T62UIUwDQRBF/+xVlDUgMCiCQaAP191LgyRBNIRAgsCiwVZVYGgtAkMICQmiggRJmpur4zQCQ1UxCDCXirZDtuGag7RNKV05M/vyZ+bvEkacOI4XO53OVq/XW3Npz/Ne8/n8o+/7n6PqKRuM43g5SZIKgAMi4n6//+LySql1EbEAbrXWZd/337P3hhBm3gDwQET1brdbKRaLH9nCRqOxlMvlyiJSArBtrX1O8wPIt4InAGVr7c0oyWmMmQ8BVLTWm6miAYSZL4goMcacTAKkuSiKqiKirbXHLkZuiEmStNwQf7cwDuha8zyvpbVedcOmZrNZEpEjY8zONCoyau6J6KpQKNQpDEPXwkoQBKd/gYRheA7gLQiC6r8gSqm2MaY2n3bmMthZVszMNQALwxXPaLZrpdSu28zAJxknTm17IjpzrhWRPWttOO4B7hNRNOkBMnNARHcO9AOSqpr2K3AgAJdfz4Xitgb1fUYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/search.png
// module id = 3vTs
// module chunks = 26